import { useTranslation } from 'react-i18next';
import { IUser } from 'types/interfaces/iUser';
import { NotifyTypo, PageHeader } from 'web-components';
import AccountForm from '../../components/forms/Account/AccountForm';
import { ContentWrapper } from '../../elements';
import withLoadingState from '../../helpers/withLoadingState';
import { PageHeaderTitleWrapper } from './elements';

interface AccountProps {
  user: IUser;
}

const Account = ({ user }: AccountProps) => {
  const { t } = useTranslation();

  return (
    <>
      <PageHeader alwaysVisible>
        <PageHeaderTitleWrapper>
          <NotifyTypo.Heading1 gutterBottom>{t('profile.account_settings')}</NotifyTypo.Heading1>
          <NotifyTypo.PageHeadingSubtitle color={undefined}>
            {t('profile.account_sub_title')}
          </NotifyTypo.PageHeadingSubtitle>
        </PageHeaderTitleWrapper>
      </PageHeader>

      <ContentWrapper
        className="withPageHeader"
        maxWidth={false}
        style={{ background: '#fff', paddingLeft: 0, paddingRight: 0 }}
      >
        <AccountForm user={user} />
      </ContentWrapper>
    </>
  );
};

export default withLoadingState(Account);
